import CalendarIconV2 from './CalendarIconV2';

export default CalendarIconV2;
